import { AuthState } from '@okta/okta-auth-js';

import { Commodities } from '../../services/backend/Commodities';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommodities: () => Commodities<AuthState> = () => {
  return useBaseApiClient(Commodities);
};
